class ChannelsService {
    constructor($http, authenticationService, globalConstants) {
        this.$http = $http;
        this.token = authenticationService.getToken();
        this.$http.defaults.headers.common.Authorization = 'Bearer ' + this.token;
        this.globalConstants = globalConstants;
    }

    getGlobalChannels() {
        return this.$http({
            method: 'GET',
            url: this.globalConstants.ApiBaseUrl + '/api/channels/getglobalchannels'
        });
    }

    getByEventId(eventId) {
        return this.$http({
            method: 'GET',
            url: this.globalConstants.ApiBaseUrl + '/api/channels/getbyeventid',
            params: { eventId: eventId}
        });
    }

    getBySubscriptionId() {
        return this.$http({
            method: 'GET',
            url: this.globalConstants.ApiBaseUrl + '/api/channels/getbysubscriptionid'
        });
    }

    getAll() {
        return this.$http({
            method: 'GET',
            url: this.globalConstants.ApiBaseUrl + '/api/channels'
        });
    }

    getByIds(query) {
        return this.$http({
            method: 'GET',
            url: this.globalConstants.ApiBaseUrl + '/api/channels/getByIds',
            params: query
        });
    }

    getById(id) {
        return this.$http({
            method: 'GET',
            url: this.globalConstants.ApiBaseUrl + '/api/channels/getById',
            params: { id: id}
        });
    }

    delete(id) {
        return this.$http({
            method: 'DELETE',
            url: this.globalConstants.ApiBaseUrl + '/api/channels/' + id
        });
    }

    deleteChannel(id) {
        return this.$http({
            method: 'DELETE',
            url: this.globalConstants.ApiBaseUrl + '/api/channels/deletechannel/',
            params: { id: id}
        });
    }

    add(channel) {
        return this.$http({
            method: 'POST',
            url: this.globalConstants.ApiBaseUrl + '/api/channels',
            data: channel
        });
    }

    update(channel) {
        return this.$http({
            method: 'PUT',
            url: this.globalConstants.ApiBaseUrl + '/api/channels',
            data: channel
        });
    }

    assignChannel(eventChannel) {
        return this.$http({
            method: 'POST',
            url: this.globalConstants.ApiBaseUrl +'/api/channels/assignchannel',
            data: eventChannel
        });
    }

    unassignChannel(eventChannel) {
        return this.$http({
            method: 'POST',
            url: this.globalConstants.ApiBaseUrl + '/api/channels/unassignchannel',
            data: eventChannel
        });
    }
}

export default ChannelsService;


// WEBPACK FOOTER //
// ./src/js/services/channels.service.js